import React from 'react';

import { formatActivityDateTime } from './organisationUserFormat';

/**
 * The member's projects in this organisation, read-only.
 */
export default function OrganisationUserProjects({ projects }) {
    return (
        <section className="tw-space-y-3">
            <h3 className="tw-mb-0 tw-text-sm tw-font-semibold tw-text-charcoal">{$t('Projects')}</h3>

            {projects.length === 0 ? (
                <p className="tw-mb-0 tw-text-sm tw-text-charcoal-50">{$t('Not on any project in this organisation.')}</p>
            ) : (
                <table className="tw-w-full tw-text-sm">
                    <thead>
                        <tr className="tw-border-b tw-border-grey tw-text-xs tw-text-charcoal-75">
                            <th className="tw-py-2 tw-pe-3 tw-text-start tw-font-medium">{$t('Project')}</th>
                            <th className="tw-py-2 tw-pe-3 tw-text-start tw-font-medium">{$t('Project role')}</th>
                            <th className="tw-py-2 tw-text-start tw-font-medium">{$t('Last login')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {projects.map((project) => (
                            <tr key={project.event_id} className="tw-border-b tw-border-grey last:tw-border-b-0">
                                <td className="tw-py-2.5 tw-pe-3 tw-text-charcoal">{project.name}</td>
                                <td className="tw-py-2.5 tw-pe-3 tw-text-charcoal">
                                    {project.role ? $t(project.role) : <span className="tw-text-charcoal-50">—</span>}
                                </td>
                                <td className="tw-py-2.5 tw-text-charcoal-50">
                                    {project.last_login_at ? formatActivityDateTime(project.last_login_at) : $t('Never')}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            <p className="tw-mb-0 tw-rounded-lg tw-bg-blue-15 tw-px-4 tw-py-3 tw-text-xs tw-text-charcoal-85">
                {$t(
                    'Departments, venues, cost centres and modules are set inside each project by an Event Admin. Organisation level sets project membership and project role only.',
                )}
            </p>
        </section>
    );
}
